// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Checkbox":"Uw0ISf4k","checkMark":"K4wlcz9U","label":"v9s4vIW9","disabled":"d2AqtJ4o","round":"me8rsEmv"};